import { Component, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  ToastController,
  LoadingController,
  AlertController,
  IonItemSliding,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EncontroNotaPessoaPage } from "../evento/encontro-nota-pessoa/encontro-nota-pessoa.page";
import { ReposicaoAddPage } from "../reposicao-add/reposicao-add.page";
import { EventoProvider } from "src/app/services/evento/evento";
import { UserProvider } from "src/app/services/user/user";
import { ServicosInscricaoPage } from "../servicos-inscricao/servicos-inscricao.page";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { BarcodeScanningModalComponent } from "src/app/components/barcode-scanning/barcode-scanning";
import { Barcode, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";

@Component({
  selector: "app-reposicao",
  templateUrl: "./reposicao.page.html",
  styleUrls: ["./reposicao.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class ReposicaoPage implements OnInit {
  loaded = false;
  filtro: any = { q: "" };
  filtroInscritos: any = { q: "" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  inscritosList: any = [];
  activeItemSliding: IonItemSliding | null = null;
  idEvento: any;
  idEncontro: any;
  isAvulso: any;
  idModulo: any;
  idAula: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public eventoProvider: EventoProvider,
    public userProvider: UserProvider
  ) {
    this.idEvento = this.navParams.get("idEvento");
    this.idEncontro = this.navParams.get("idEncontro");
    this.isAvulso = this.navParams.get("isAvulso");
    this.idModulo = this.navParams.get("idModulo");
    this.idAula = this.navParams.get("idAula");
  }

  ngOnInit() {
    this.loadInscritos(null);

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  onInputInscritos() {
    this.inscritosList = [];
    this.pagination = { currentPage: 0, pageCount: 0 };
    this.loadInscritos(null);
  }

  loadInscritos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;
    this.eventoProvider.getReposicao(this.filtroInscritos, this.pagination, this.idEncontro).subscribe((res) => {
      this.inscritosList = this.inscritosList.concat(res.inscritos);
      this.pagination = res.pagination;

      if (infiniteScroll) {
        infiniteScroll.target.complete();
      }
    });
  }

  async notas(participante: { idEncontro: any }) {
    let data = { idEncontro: participante.idEncontro, participante: participante };
    const modalPage = await this.modalCtrl.create({ component: EncontroNotaPessoaPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data;
    this.inscritosList = [];
    this.pagination = { currentPage: 0, pageCount: 0 };
    this.loadInscritos(null);
  }

  changeCheck(participante: {
    presenca: string;
    data_check_in: string;
    idEventoEncontroPresenca: any;
    idEventoInscricao: any;
  }) {
    if (participante.presenca == "1") {
      participante.presenca = "0";
      participante.data_check_in = "";
    } else {
      participante.presenca = "1";
      participante.data_check_in = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    }

    this.eventoProvider.salvarPresencaParticipante(participante).subscribe(async (data) => {
      participante.idEventoEncontroPresenca = data.id;
      if (this.isAvulso && participante.presenca == "1") {
        let params = {
          idInscricao: participante.idEventoInscricao,
          idPresenca: participante.idEventoEncontroPresenca,
          isAvulso: this.isAvulso,
        };
        const modalPage = await this.modalCtrl.create({ component: ServicosInscricaoPage, componentProps: params });
        modalPage.present();
      }
    });
  }

  openOption(itemSlide: any, item: any, participante: any) {
    if (this.activeItemSliding) {
      return this.closeOption();
    }

    this.activeItemSliding = itemSlide;

    let swipeAmount = 104;

    itemSlide.startSliding(swipeAmount);
    itemSlide.moveSliding(swipeAmount);

    itemSlide.setElementClass("active-options-right", true);
    itemSlide.setElementClass("active-swipe-right", true);

    item.setElementStyle("transition", null);
    item.setElementStyle("transform", "translate3d(-" + swipeAmount + "px, 0px, 0px)");
  }

  closeOption() {
    if (this.activeItemSliding) {
      this.activeItemSliding.close();
      this.activeItemSliding = null;
    }
  }

  leitor = async () => {
    const formats = LensFacing.Back || [];
    const lensFacing = LensFacing.Back;

    const element = await this.modalCtrl.create({
      component: BarcodeScanningModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
      componentProps: {
        formats: formats,
        lensFacing: lensFacing,
        text: "Leitor",
      },
    });
    element.present();

    element.onDidDismiss().then(async (result: any) => {
      const barcode: Barcode | undefined = result.data?.barcode;
      if (barcode?.displayValue) {
        const code = this.tratarCodigoScaneado(barcode?.displayValue);
        if (code) {
          this.filtroInscritos.q = code.N;
          this.onInputInscritos();
        } else {
          BarcodeScanner.stopScan();
          const alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Atenção"),
            message: this.translate.instant(
              "Não foi possível abrir a câmera do celular. Valide as permissões do aplicativo"
            ),
            buttons: [
              {
                text: this.translate.instant("Fechar"),
              },
            ],
          });

          alert.present();
        }
      }
    });
  };

  tratarCodigoScaneado(code: string) {
    var aux = JSON.parse(code);
    return aux;
  }

  async addReposicao() {
    let params = {
      idEncontro: this.idEncontro,
      idEvento: this.idEvento,
      idModulo: this.idModulo,
      idAula: this.idAula,
      isAvulso: this.isAvulso,
    };
    const modalPage = await this.modalCtrl.create({ component: ReposicaoAddPage, componentProps: params });
    modalPage.present();

    const data = await modalPage.onWillDismiss();
    if (data) {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.filtro = { q: "" };
      this.loadInscritos(null);
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
